import React from "react";
import { makeStyles } from "tss-react/mui";

import { Typography } from "@mui/material";

const useStyles = makeStyles()((theme) => ({
    subTitle: {
        fontWeight: 600,
        display: "block",
        marginBottom: theme.spacing(1),
    },
}));

export function TopicHeader({ children }: React.ComponentProps<"span">): React.JSX.Element {
    const { classes } = useStyles();

    return <Typography className={classes.subTitle}>{children}</Typography>;
}
